import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandler } from '@app/shared/services/http-error-handler.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ISpringResponseBody, observeTypes } from '@app/shared/interfaces/response-interfaces';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { AppConfig } from '@app/config/app.config';
import { catchError, map } from 'rxjs/operators';
import { SearchUserRequestParams } from '@app/profile/settings/settings';

@Injectable()
export class ProfileService {
  private handleError: HandleError;
  private headerHelper: any;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private store: Store<any>,
    private http: HttpClient
  ) {
    this.headerHelper = new HeadersSetterHelper(this.store);
    this.handleError = httpErrorHandler.createHandleError('ProfileService');
  }

  getRemainingCount(): Observable<ISpringResponseBody | any> {
      return this.http.get<ISpringResponseBody>(
        AppConfig.endpoints.profile.remainingCount, this.headerHelper.options(observeTypes.BODY)
      ).pipe(
        catchError(this.handleError('getRemainingCount')),
        map(res => res),
      );
  }

  searchUser(options: SearchUserRequestParams): Observable<ISpringResponseBody | any>  {
   return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.profile.search, this.buildRequestOptions(options))
      .pipe(
        catchError(this.handleError('getUser'))
      );
  }

  buildRequestOptions(options: SearchUserRequestParams) {
    let params = new HttpParams();
    Object.keys(options).forEach(key => {
        params = params.set(key, options[key]);
    });
    const requestOptions = this.headerHelper.historyOptions(observeTypes.BODY, params);
    return requestOptions;
  }
}
